import { CacheLocation } from '@auth0/auth0-react'

const clientIdDev = '2TrXtLOnwAUt4gYri3Kwdr0CjqilIioQ'
const clientIdStaging = 'UA1MjBuVTYmWo476c3DHeoj5ZAazoq6b'
const clientIdProduction = 'KkAm23hah6CCnJbmZPlM8QPZfmOCLdZS'

export enum Environment {
  LOCAL,
  PREVIEW,
  DEV,
  STAGING,
  PRODUCTION,
}

declare global {
  interface Window {
    Cypress?: unknown
  }
}

type Auth0ConfigMap = {
  domain: string
  client_id: string
  audience: string
  redirect: string
  cacheLocation: CacheLocation
}

const auth0ConfigMap = (environment: Environment): Auth0ConfigMap => {
  switch (environment) {
    case Environment.STAGING:
      return {
        domain: 'partner.staging.entur.org',
        client_id: clientIdStaging,
        audience: 'https://api.staging.entur.io/personnelticket/v2/',
        redirect: 'https://fordelsreise.staging.entur.no',
        cacheLocation: 'memory',
      }
    case Environment.PRODUCTION:
      return {
        domain: 'partner.entur.org',
        client_id: clientIdProduction,
        audience: 'https://api.entur.io/personnelticket/v2/',
        redirect: 'https://fordelsreise.entur.no',
        cacheLocation: 'memory',
      }
    case Environment.DEV:
      return {
        domain: 'partner.dev.entur.org',
        client_id: clientIdDev,
        audience: 'https://api.dev.entur.io/personnelticket/v2/',
        redirect: 'https://fordelsreise.dev.entur.no',
        cacheLocation: 'memory',
      }
    case Environment.PREVIEW:
      return {
        domain: 'partner.staging.entur.org',
        client_id: clientIdStaging,
        audience: 'https://api.staging.entur.io/personnelticket/v2/',
        redirect: window.location.origin,
        cacheLocation: 'memory',
      }
    default:
      return {
        domain: 'partner.dev.entur.org',
        client_id: clientIdDev,
        audience: 'https://api.dev.entur.io/personnelticket/v2/',
        redirect: 'http://localhost:3000',
        cacheLocation: window.Cypress ? 'localstorage' : 'memory',
      }
  }
}

export const getAuth0Config = () => {
  return auth0ConfigMap(getEnvironment())
}

type ApiConfig = {
  url: string
}
const apiConfig = (environment: Environment): ApiConfig => {
  switch (environment) {
    case Environment.DEV:
      return { url: 'https://api.dev.entur.io' }
    case Environment.STAGING:
      return { url: 'https://api.staging.entur.io' }
    case Environment.PRODUCTION:
      return { url: 'https://api.entur.io' }
    case Environment.PREVIEW:
      return { url: 'https://api.staging.entur.io' }
    default:
      return { url: 'https://api.dev.entur.io' }
  }
}

export const getApiConfig = () => {
  return apiConfig(getEnvironment())
}

export const getEnvironment = (): Environment => {
  if (window.location.origin.includes('preview')) {
    return Environment.PREVIEW
  }
  switch (window.location.origin) {
    case 'https://fordelsreise.dev.entur.no':
      return Environment.DEV
    case 'https://fordelsreise.staging.entur.no':
      return Environment.STAGING
    case 'https://fordelsreise.entur.no':
      return Environment.PRODUCTION
    default:
      return Environment.LOCAL
  }
}

// eslint-disable-next-line no-console
export const deprecationWarning =
  getEnvironment() !== Environment.PRODUCTION
    ? console.warn
    : () => {
        // do nothing
      }

// eslint-disable-next-line no-console
export const warn =
  getEnvironment() !== Environment.PRODUCTION
    ? console.warn
    : () => {
        // do nothing
      }
